<template>
  <ConfirmDialog />
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li><a class="text-500 no-underline line-height-3 cursor-pointer">COMISIONES</a></li>
    <li class="px-2"><i class="pi pi-angle-right text-500 line-height-3"></i></li>
    <li><span class="text-900 line-height-3">OBJETIVOS DE COMISION</span></li>
  </ul>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />

    <div class="flex align-items-center justify-content-between mb-3">
      <div class="font-medium text-3xl text-900">
        Objetivos de Comisión <Badge size="xlarge" severity="success">{{ objetivos.length }}</Badge>
      </div>
      <div class="flex gap-2">
        <Button
          icon="pi pi-refresh"
          class="p-button-info p-button-outlined"
          v-tooltip.top="'Actualizar'"
          @click="cargarObjetivos"
        />
        <Button label="NUEVO" icon="pi pi-plus" class="p-button-info" @click="openNuevo" />
      </div>
    </div>

    <div class="surface-100 p-2 border-round mb-3 border-1 surface-border flex gap-2 align-items-end flex-wrap">
      <div v-if="sucursales.length > 1" style="min-width: 160px; flex: 1">
        <span><strong>SUCURSAL:</strong></span>
        <Dropdown
          v-model="filtros.sucursal_id"
          :options="sucursales"
          optionLabel="nombre"
          optionValue="id"
          placeholder="Todas"
          showClear
          class="w-full"
          @change="cargarObjetivos"
        />
      </div>
      <div style="min-width: 140px; flex: 1">
        <span><strong>NOMBRE:</strong></span>
        <InputText v-model="filtros.nombre" placeholder="Buscar..." class="w-full" @keyup.enter="cargarObjetivos" />
      </div>
      <div style="min-width: 130px; flex: 1">
        <span><strong>MES:</strong></span>
        <Dropdown
          v-model="filtros.mes"
          :options="meses"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos"
          showClear
          class="w-full"
          @change="cargarObjetivos"
        />
      </div>
      <div style="min-width: 90px; flex: 0 0 100px">
        <span><strong>ANO:</strong></span>
        <InputText type="number" v-model="filtros.anio" class="w-full" @change="cargarObjetivos" />
      </div>
      <div style="min-width: 120px; flex: 1">
        <span><strong>ESTADO:</strong></span>
        <Dropdown
          v-model="filtros.estado"
          :options="estados"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos"
          showClear
          class="w-full"
          @change="cargarObjetivos"
        />
      </div>
      <Button icon="pi pi-search" label="BUSCAR" class="p-button-primary p-button-outlined" @click="cargarObjetivos" />
    </div>

    <DataTable
      :value="objetivos"
      :loading="cargando"
      dataKey="id"
      class="p-datatable-sm"
      responsiveLayout="scroll"
      showGridlines
      stripedRows
      v-model:expandedRows="expandedRows"
    >
      <template #loading>
        <div class="flex align-items-center justify-content-center p-4"><ProgressSpinner /></div>
      </template>
      <template #empty>
        <div class="text-center p-4" style="color: #888">
          <i class="pi pi-inbox" style="font-size: 2rem"></i>
          <p class="mt-2">No hay objetivos registrados</p>
        </div>
      </template>

      <Column expander style="width: 3rem" />
      <Column field="id" header="#" style="width: 55px" />
      <Column field="nombre" header="NOMBRE" />
      <Column v-if="sucursales.length > 1" field="sucursal_nombre" header="SUCURSAL" />
      <Column header="PERIODO" style="width: 140px">
        <template #body="{ data }">
          <strong>{{ mesTexto(data.mes) }}</strong> {{ data.anio }}
        </template>
      </Column>
      <Column header="ESCALAS">
        <template #body="{ data }">
          <span
            v-for="e in data.escalas"
            :key="e.id"
            class="mr-2"
            style="
              display: inline-block;
              background: #1e3a5f;
              color: #fff;
              border-radius: 4px;
              padding: 2px 8px;
              font-size: 12px;
              font-weight: 600;
            "
          >
            E{{ e.escala }}: Bs.{{ e.monto }}
          </span>
        </template>
      </Column>
      <Column header="SERVICIOS" style="width: 100px">
        <template #body="{ data }">
          <span
            style="cursor: pointer; color: #1e3a5f; font-weight: 700; font-size: 15px"
            v-tooltip.top="'Ver servicios del objetivo'"
            @click="abrirModalServicios(data)"
          >
            {{ data.productos.length }}
            <i class="pi pi-list ml-1"></i>
          </span>
        </template>
      </Column>
      <Column header="ESTADO" style="width: 120px">
        <template #body="{ data }">
          <span :style="data.estado == 1 ? 'color:#27ae60;font-weight:700' : 'color:#e67e22;font-weight:700'">
            <i :class="data.estado == 1 ? 'pi pi-check-circle' : 'pi pi-lock'" class="mr-1"></i>
            {{ data.estado == 1 ? 'ACTIVO' : 'LIQUIDADO' }}
          </span>
        </template>
      </Column>
      <Column style="width: 60px">
        <template #body="slotProps">
          <Button
            class="p-button-icon-only p-button-raised p-button-info p-button-sm"
            icon="pi pi-ellipsis-v"
            @click="$refs['menu' + slotProps.data.id].toggle($event)"
          />
          <Menu :ref="'menu' + slotProps.data.id" :popup="true" :model="acciones(slotProps.data)" />
        </template>
      </Column>

      <template #expansion="slotProps">
        <div class="p-3">
          <div class="flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <span
              style="
                font-size: 15px;
                font-weight: 700;
                color: #1e3a5f;
                border-bottom: 2px solid #1e3a5f;
                padding-bottom: 3px;
              "
            >
              <i class="pi pi-chart-bar mr-2"></i>AVANCE - {{ slotProps.data.nombre }}
              <small class="ml-2" style="color: #888; font-weight: 400"
                >{{ mesTexto(slotProps.data.mes) }} {{ slotProps.data.anio }}</small
              >
            </span>
            <Button
              v-if="puedeLiquidar(slotProps.data)"
              label="LIQUIDAR COMISIONES"
              icon="pi pi-check-circle"
              class="p-button-warning"
              @click="confirmarLiquidar(slotProps.data)"
            />
          </div>

          <div v-if="loadingAvance[slotProps.data.id]" class="flex align-items-center p-3">
            <ProgressSpinner style="width: 25px; height: 25px" />
            <span class="ml-2" style="color: #888">Cargando...</span>
          </div>

          <template v-else-if="avances[slotProps.data.id]">
            <div class="flex gap-2 mb-3 flex-wrap">
              <div
                v-for="e in avances[slotProps.data.id].escalas"
                :key="e.id"
                class="border-round p-2 text-center"
                style="background: #f0f7ff; border: 1px solid #bee3f8"
              >
                <div style="font-size: 11px; color: #1e3a5f; font-weight: 900">ESCALA {{ e.escala }}</div>
                <div style="font-size: 12px; color: #555; margin: 2px 0; font-weight: 600">
                  {{ e.desde }}-{{ e.hasta ?? 'inf' }}
                </div>
                <div style="font-size: 18px; font-weight: 700; color: #27ae60">Bs. {{ e.monto }}</div>
              </div>
            </div>

            <DataTable :value="avances[slotProps.data.id].avances" class="p-datatable-sm" showGridlines stripedRows>
              <template #empty>
                <div class="text-center p-3" style="color: #888">
                  <i class="pi pi-inbox mr-1"></i> Sin servicios registrados en este mes
                </div>
              </template>

              <Column header="TRABAJADOR" style="width: 130px">
                <template #body="{ data }">
                  <span style="font-weight: 700; font-size: 14px">{{ data.nombre_completo }}</span>
                </template>
              </Column>

              <Column header="SERVICIOS" style="width: 150px">
                <template #body="{ data }">
                  <div class="flex align-items-center justify-content-between">
                    <span style="font-size: 16px; font-weight: 700; color: #1e3a5f">
                      {{ parseInt(data.total_unidades) }}
                      <span style="color: #888; font-weight: 400; font-size: 16px"> Serv.</span>
                      - <span style="color: #27ae60">Bs. {{ formatoNumero(data.total_monto) }}</span>
                    </span>
                    <Button
                      v-if="data.detalle && data.detalle.length"
                      icon="pi pi-list"
                      class="p-button-info p-button-text p-button-lg"
                      v-tooltip.top="'Ver detalle'"
                      @click="abrirDetalleAvance(data)"
                    />
                  </div>
                </template>
              </Column>

              <Column header="ESCALA" style="width: 90px; text-align: center">
                <template #body="{ data }">
                  <div class="flex justify-content-center">
                    <span
                      v-if="data.escala_actual"
                      style="
                        background: #27ae60;
                        color: #fff;
                        border-radius: 4px;
                        padding: 3px 10px;
                        font-weight: 700;
                        font-size: 13px;
                      "
                    >
                      Escala {{ data.escala_actual }}
                    </span>
                    <span v-else style="color: #e74c3c; font-weight: 600">
                      <i class="pi pi-times-circle mr-1"></i>Sin escala
                    </span>
                  </div>
                </template>
              </Column>

              <Column header="COMISION A COBRAR" style="width: 110px; text-align: center">
                <template #body="{ data }">
                  <div class="flex justify-content-center">
                    <span style="font-size: 20px; font-weight: 700; color: #27ae60">
                      Bs. {{ formatoNumero(data.monto_a_pagar) }}
                    </span>
                  </div>
                </template>
              </Column>

              <Column header="FALTA PARA SIGUIENTE" style="width: 130px">
                <template #body="{ data }">
                  <div v-if="data.siguiente_escala" style="color: #e67e22">
                    <div style="font-size: 16px; font-weight: 700">
                      <i class="pi pi-arrow-up mr-1"></i>{{ data.siguiente_escala.falta }} mas
                    </div>
                    <div style="font-size: 12px; color: #888; margin-top: 2px">
                      Escala {{ data.siguiente_escala.escala }}: Bs. {{ data.siguiente_escala.monto }}
                    </div>
                  </div>
                  <span v-else style="color: #27ae60; font-weight: 700">
                    <i class="pi pi-check-circle mr-1"></i>Escala maxima
                  </span>
                </template>
              </Column>
            </DataTable>
          </template>

          <div v-else class="text-center p-3" style="color: #888">
            <i class="pi pi-spin pi-spinner mr-1"></i> Cargando...
          </div>
        </div>
      </template>
    </DataTable>

    <!-- MODAL DETALLE AVANCE -->
    <Dialog
      v-model:visible="modalDetalleAvance"
      :style="{ width: '450px' }"
      :header="'Detalle - ' + (detalleAvanceData.nombre_completo ?? '')"
      :modal="true"
      class="p-fluid"
    >
      <div v-if="detalleAvanceData.detalle && detalleAvanceData.detalle.length">
        <div class="flex justify-content-between mb-2 p-2" style="background: #f0f7ff; border-radius: 4px">
          <span style="font-weight: 700">Total servicios: {{ detalleAvanceData.total_unidades }}</span>
          <span style="font-weight: 700; color: #27ae60">Bs. {{ formatoNumero(detalleAvanceData.total_monto) }}</span>
        </div>
        <table style="border-collapse: collapse; width: 100%; font-size: 13px">
          <thead>
            <tr style="background: #1e3a5f; color: #fff">
              <th style="padding: 8px; text-align: left">SERVICIO</th>
              <th style="padding: 8px; text-align: right; width: 60px">CANT.</th>
              <th style="padding: 8px; text-align: right; width: 100px">MONTO</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="d in detalleAvanceData.detalle" :key="d.producto_nombre" style="border-bottom: 1px solid #eee">
              <td style="padding: 6px 8px">{{ d.producto_nombre }}</td>
              <td style="padding: 6px 8px; text-align: right; font-weight: 700">{{ d.cantidad }}</td>
              <td style="padding: 6px 8px; text-align: right; color: #555">Bs. {{ formatoNumero(d.monto_total) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <Button label="CERRAR" icon="pi pi-times" class="p-button-secondary" @click="modalDetalleAvance = false" />
      </template>
    </Dialog>

    <!-- MODAL SERVICIOS -->
    <Dialog
      v-model:visible="modalServicios"
      :style="{ width: '400px' }"
      header="Servicios del Objetivo"
      :modal="true"
      class="p-fluid"
    >
      <div v-if="serviciosModal.length">
        <div
          v-for="s in serviciosModal"
          :key="s.producto_id"
          class="flex align-items-center p-2 border-bottom-1 surface-border"
        >
          <i class="pi pi-wrench mr-2 text-primary"></i>
          <span style="font-weight: 600">{{ s.descripcion }}</span>
        </div>
      </div>
      <template #footer>
        <Button label="CERRAR" icon="pi pi-times" class="p-button-secondary" @click="modalServicios = false" />
      </template>
    </Dialog>

    <!-- MODAL LIQUIDAR -->
    <Dialog
      v-model:visible="modalLiquidar"
      :style="{ width: '500px' }"
      header="Confirmar Liquidacion"
      :modal="true"
      class="p-fluid"
    >
      <div v-if="objetivoALiquidar" class="text-center p-3">
        <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: #e67e22"></i>
        <div class="mt-3" style="font-size: 20px; font-weight: 700; color: #1e3a5f">
          Liquidar {{ mesTexto(objetivoALiquidar.mes) }} {{ objetivoALiquidar.anio }}
        </div>
        <div class="mt-1 mb-3" style="font-size: 14px; color: #888">{{ objetivoALiquidar.nombre }}</div>

        <div v-if="avances[objetivoALiquidar.id]" class="surface-100 border-round p-3 text-left">
          <div
            v-for="a in avances[objetivoALiquidar.id].avances"
            :key="a.medico_id"
            class="flex justify-content-between align-items-center py-2 border-bottom-1 surface-border"
          >
            <div>
              <div style="font-weight: 700; font-size: 15px">{{ a.nombre_completo }}</div>
              <div style="font-size: 12px; color: #888">
                {{ a.total_unidades }} servicios - Escala {{ a.escala_actual ?? '-' }}
              </div>
            </div>
            <span style="font-size: 20px; font-weight: 700; color: #27ae60"
              >Bs. {{ formatoNumero(a.monto_a_pagar) }}</span
            >
          </div>
          <div class="flex justify-content-between align-items-center pt-3 mt-1" style="border-top: 2px solid #1e3a5f">
            <span style="font-weight: 700; font-size: 16px">TOTAL A PAGAR</span>
            <span style="font-size: 22px; font-weight: 700; color: #27ae60">
              Bs.
              {{ formatoNumero(avances[objetivoALiquidar.id].avances.reduce((s, a) => s + (a.monto_a_pagar ?? 0), 0)) }}
            </span>
          </div>
        </div>

        <div class="mt-3 p-2 border-round" style="background: #fff3cd; color: #856404; font-size: 13px">
          <i class="pi pi-info-circle mr-1"></i>
          Esta accion <strong>no se puede deshacer</strong>. Las comisiones se registraran para cada trabajador.
        </div>
      </div>
      <template #footer>
        <Button
          label="CANCELAR"
          icon="pi pi-times"
          class="p-button-secondary p-button-lg"
          @click="modalLiquidar = false"
        />
        <Button
          label="SI, LIQUIDAR"
          icon="pi pi-check-circle"
          class="p-button-warning p-button-lg"
          :loading="liquidando"
          @click="ejecutarLiquidar"
        />
      </template>
    </Dialog>

    <ObjetivoComisionCreate
      :show="objetivoDialog"
      :objetivo="objetivo"
      :sucursales="sucursales"
      :productos="productos"
      @closeModal="ocultarDialog"
      @actualizarListado="cargarObjetivos"
    />
  </div>
</template>

<script>
import ObjetivoComisionService from '@/service/ObjetivoComisionService'
import ObjetivoComisionCreate from '@/module/comisiones/ObjetivoComisionCreate.vue'
import { useAuth } from '@/stores'

export default {
  components: { ObjetivoComisionCreate },

  data() {
    return {
      objetivos: [],
      sucursales: [],
      productos: [],
      cargando: false,
      filtros: { sucursal_id: null, mes: null, anio: new Date().getFullYear(), estado: null, nombre: null },
      objetivoDialog: false,
      objetivo: {},
      expandedRows: [],
      avances: {},
      loadingAvance: {},
      detalleExpandido: {},
      modalServicios: false,
      serviciosModal: [],
      modalDetalleAvance: false,
      detalleAvanceData: {},
      modalLiquidar: false,
      objetivoALiquidar: null,
      liquidando: false,
      estados: [
        { label: 'ACTIVO', value: 1 },
        { label: 'LIQUIDADO', value: 0 }
      ],
      meses: [
        { label: 'ENERO', value: 1 },
        { label: 'FEBRERO', value: 2 },
        { label: 'MARZO', value: 3 },
        { label: 'ABRIL', value: 4 },
        { label: 'MAYO', value: 5 },
        { label: 'JUNIO', value: 6 },
        { label: 'JULIO', value: 7 },
        { label: 'AGOSTO', value: 8 },
        { label: 'SEPTIEMBRE', value: 9 },
        { label: 'OCTUBRE', value: 10 },
        { label: 'NOVIEMBRE', value: 11 },
        { label: 'DICIEMBRE', value: 12 }
      ]
    }
  },

  created() {
    this.auth = useAuth()
    this.objetivoComisionService = new ObjetivoComisionService()
  },

  mounted() {
    this.objetivoComisionService.datosNecesarios().then((res) => {
      this.sucursales = res.sucursales ?? []
      this.productos = res.productos ?? []
    })
    this.cargarObjetivos()
  },

  methods: {
    cargarObjetivos() {
      this.cargando = true
      this.avances = {}
      this.expandedRows = []
      const params = Object.fromEntries(
        Object.entries(this.filtros).filter(([, v]) => v !== null && v !== undefined && v !== '')
      )
      this.objetivoComisionService
        .getAll(params)
        .then((res) => {
          this.objetivos = res.objetivos ?? []
        })
        .finally(() => {
          this.cargando = false
        })
    },

    cargarAvance(id) {
      this.loadingAvance[id] = true
      this.objetivoComisionService
        .avance(id)
        .then((res) => {
          this.avances[id] = res
        })
        .finally(() => {
          this.loadingAvance[id] = false
        })
    },

    puedeLiquidar(datos) {
      if (datos.estado == 0) return false
      const ahora = new Date()
      const mesActual = ahora.getMonth() + 1
      const anioActual = ahora.getFullYear()
      return datos.anio < anioActual || (datos.anio == anioActual && datos.mes < mesActual)
    },

    abrirDetalleAvance(data) {
      this.detalleAvanceData = data
      this.modalDetalleAvance = true
    },

    abrirModalServicios(datos) {
      this.serviciosModal = datos.productos ?? []
      this.modalServicios = true
    },

    confirmarLiquidar(datos) {
      this.objetivoALiquidar = datos
      this.modalLiquidar = true
    },

    ejecutarLiquidar() {
      if (!this.objetivoALiquidar) return
      this.liquidando = true
      this.objetivoComisionService
        .liquidar(this.objetivoALiquidar.id)
        .then((res) => {
          this.$toast.add({
            severity: res.success ? 'success' : 'error',
            summary: res.success ? 'Exito' : 'Error',
            detail: res.message,
            life: 3000
          })
          if (res.success) {
            this.modalLiquidar = false
            this.objetivoALiquidar = null
            this.cargarObjetivos()
          }
        })
        .finally(() => {
          this.liquidando = false
        })
    },

    openNuevo() {
      this.objetivo = {}
      this.objetivoDialog = true
    },
    ocultarDialog() {
      this.objetivoDialog = false
      this.objetivo = {}
    },

    acciones(datos) {
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          disabled: datos.estado == 0,
          command: () => {
            this.objetivo = { ...datos }
            this.objetivoDialog = true
          }
        },
        { label: 'Copiar al mes siguiente', icon: 'pi pi-copy', command: () => this.abrirCopia(datos) },
        { label: 'Eliminar', icon: 'pi pi-trash', command: () => this.eliminar(datos.id) }
      ]
    },

    abrirCopia(datos) {
      const mes = datos.mes == 12 ? 1 : datos.mes + 1
      const anio = datos.mes == 12 ? datos.anio + 1 : datos.anio
      this.objetivo = {
        ...datos,
        id: null,
        mes,
        anio,
        nombre: datos.nombre,
        estado: 1
      }
      this.objetivoDialog = true
    },

    eliminar(id) {
      this.$confirm.require({
        message: 'Eliminar este objetivo?',
        header: 'Confirmacion',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Si, eliminar',
        rejectLabel: 'Cancelar',
        accept: () => {
          this.objetivoComisionService.destroy(id).then((res) => {
            this.$toast.add({
              severity: res.success ? 'success' : 'error',
              summary: res.success ? 'Exito' : 'Error',
              detail: res.message,
              life: 3000
            })
            if (res.success) this.cargarObjetivos()
          })
        }
      })
    },

    mesTexto(mes) {
      return this.meses.find((m) => m.value == mes)?.label ?? mes
    },

    formatoNumero(n) {
      if (!n && n !== 0) return '0,00'
      return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n)
    }
  },

  watch: {
    expandedRows(newVal) {
      if (!newVal?.length) return
      newVal.forEach((row) => {
        if (!this.avances[row.id]) this.cargarAvance(row.id)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';
.p-invalid {
  color: red;
}
</style>
